import type { RootState } from "../index";

export const selectProfileData = (
  state: RootState,
): RootState["profile"]["profileData"] => state.profile.profileData;
export const selectProgressStats = (
  state: RootState,
): RootState["profile"]["progressStats"] => state.profile.progressStats;
export const selectLoadingProfile = (state: RootState): boolean =>
  state.profile.loadingProfile;
export const selectLoadingStats = (state: RootState): boolean =>
  state.profile.loadingStats;
export const selectSavingProfile = (state: RootState): boolean =>
  state.profile.savingProfile;
export const selectErrorProfile = (
  state: RootState,
): string | null | undefined => state.profile.errorProfile;
export const selectErrorStats = (state: RootState): string | null | undefined =>
  state.profile.errorStats;
export const selectErrorSave = (state: RootState): string | null | undefined =>
  state.profile.errorSave;
